import React from "react";
import { TransferRequestContainer } from "../../../../../containers";
const TransferRequest = (props) => {
  return <TransferRequestContainer {...props} />;
};

export default TransferRequest;
